export default __webpack_public_path__ + "static/media/escaloncito1.62c8559b.jpeg";